import React from 'react'
import Head from 'next/head'
import NgsoRoute from '@src/routes/Configurators/products/Ngso'
import { useIntl } from 'react-intl'

const Ngso = () => {
  const intl = useIntl()

  return (
    <React.Fragment>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'CONF_NEXT_GEN_SEQUENCING_OLIGOS_NGSO',
            defaultMessage: 'Next-Gen Sequencing Oligos',
          })}
        </title>
      </Head>
      <NgsoRoute />
    </React.Fragment>
  )
}

export default Ngso
